class CampaignFeedCtrl {

    constructor($scope, CONTENT_TYPE, $apiService, $routeParams, $feedService, $campaignService, Notification, EVENTS, $rootScope) {
        this.$apiService = $apiService;
        this.CONTENT_TYPE = CONTENT_TYPE;
        this.advertiserId = $routeParams.advertiserId;
        this.$feedService = $feedService;
        this.$campaignService = $campaignService;
        this.Notification = Notification;
        this.EVENTS = EVENTS;
        this.$rootScope = $rootScope;

        this.hasFeed = false;
        this.noFeeds = true;
        this.useFeed = false;
        this.isSaving = false;
        this.feeds = [];
        this.macrosAndDims = [];
        this.feedFields = [];
        this.features = [];
        this.campaign = {};

        $apiService.get(this.CONTENT_TYPE.CAMPAIGN, $routeParams.campaignId)
            .then(resp => {
                this.campaign = resp.data;
                $scope.campaign = this.campaign;
                this.getFeeds();
                if (resp.data.length === 0) {
                    this.noResults = true;
                }
            }, err => {
                if (err.status === 404) {
                    this.noResults = true;
                } else {
                    this.error = true;
                    console.error(err);
                }
            });
    }

    save() {
        this.isSaving = true;
        let feedId = (this.useFeed === false)
            ? null
            : this.selectedFeed.id;
        let features = (this.useFeed === false)
            ? []
            : this.features;
        this.$campaignService.saveFeatures(this.campaign.id, feedId, features)
            .then(resp => {
                this.$rootScope.$emit(this.EVENTS.SHOW_NOTIFICATION, {'message': "Saved succesful."});
                this.isSaving = false;
            }, err => {
                this.error = true;
                this.isSaving = false;
                console.error(err);
            });

    }

    deleteFeature(idx) {
        this.features.splice(idx, 1);
    }

    changeFeed(feedId) {

        this.$apiService.get(this.CONTENT_TYPE.FEED, feedId)
            .then(resp => {
                this.getFeedFields(feedId);
                if (resp.data.length === 0) {
                    this.noResults = true;
                }
            }, err => {
                if (err.status === 404) {
                    this.noResults = true;
                } else {
                    this.error = true;
                    console.error(err);
                }
            });

    }

    getFeeds() {

        this.$apiService.list(this.CONTENT_TYPE.FEED, 'advertiser=' + this.advertiserId)
            .then(resp => {
                this.feeds = resp.data;
                if (!!this.campaign.feedId ) {
                    this.useFeed = true;
                    this.selectedFeed = this.feeds.filter(filter => filter.id === this.campaign.feedId)[0];
                    this.getFeedFields(this.campaign.feedId);
                }
                if (resp.data.length === 0) {
                    this.noResults = true;
                }
            }, err => {
                if (err.status === 404) {
                    this.noResults = true;
                } else {
                    this.error = true;
                    console.error(err);
                }
            });

    }

    getFeedFields(feedId) {
        this.$feedService.getFeedFields(feedId)
            .then(resp => {
                this.feedFields = resp.data;
                this.features = this.campaign.features || [];
                if (resp.data.length === 0) {
                    this.noResults = true;
                }
            }, err => {
                if (err.status === 404) {
                    this.noResults = true;
                } else {
                    this.error = true;
                    console.error(err);
                }
            });

    }

    addFeature() {
        this.features.push({});
    }

    changeValueType(type) {
        if(type.value != "value") {
            if(!!type.customValue) {
                type.customValue = undefined;
            }
        }
    }

    changeType(type) {
        if(!!type.customValue) {
            type.customValue = undefined;
        }
    }

}

angular.module("cpm").controller("CampaignFeedCtrl", ["$scope", 'CONTENT_TYPE', 'ApiService', '$routeParams', '$feedService', 'CampaignService', 'Notification', 'EVENTS', '$rootScope', CampaignFeedCtrl]);